module.exports = __webpack_public_path__ + "img/1_04.3590ec5c.jpg";